import { __decorate } from "tslib";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ApplicationCreateService } from "../application-create.service";
import { AflaModuleStrategyService } from "../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../shared/services/selected-application/selected-application.service";
import { SearchApplicationsService } from "../../../search-applications/shared/search-applications.service";
import { Subject } from "rxjs";
import { AutoUnsubPortal } from "../../../shared/decorators/autounsub-portal.decorator";
let CreateApplicationViewBaseComponent = class CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    searchApplicationsService;
    _destroy$ = new Subject();
    stepMeta;
    jobId = null;
    moduleId = null;
    selectedApplication;
    isApplicationLoadedFromTheSearchPage;
    incompleteJobIdSubscription;
    selectedApplicationSubscription;
    isApplicationLoadedFromSearchPageSubscription;
    startMetadataSubscription;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService) {
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.searchApplicationsService = searchApplicationsService;
        this.incompleteJobIdSubscription = this.selectedApplicationService.$incompleteJobId.subscribe((jobId) => {
            if (jobId && jobId > 0) {
                this.jobId = jobId;
            }
        });
        this.selectedApplicationSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            this.selectedApplication = +this.jobId > 0 && application ? application : null;
        });
        this.isApplicationLoadedFromSearchPageSubscription = this.searchApplicationsService.isApplicationLoadedFromSearchPage.subscribe({
            next: (isApplicationLoadedFromSearchPage) => {
                this.isApplicationLoadedFromTheSearchPage = isApplicationLoadedFromSearchPage;
            }
        });
    }
    static checkIfChanged(newValue, oldValue) {
        if (!newValue) {
            throw new Error("Value must exist");
        }
        return newValue !== oldValue;
    }
    getMetadata() {
        this.startMetadataSubscription = this.applicationCreateService.$startMetadata.subscribe(stepMeta => {
            if (stepMeta != null) {
                this.stepMeta = stepMeta;
                this.loadMetadata(this.stepMeta);
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: SearchApplicationsService }
    ];
};
CreateApplicationViewBaseComponent = __decorate([
    Component({
        template: "",
        changeDetection: ChangeDetectionStrategy.OnPush,
        host: { "CreateApplicationViewBaseComponent": "create-application" }
    }),
    AutoUnsubPortal()
], CreateApplicationViewBaseComponent);
export { CreateApplicationViewBaseComponent };
